var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function ArrowDoubleIconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.29289 5.70711L10.5858 12L4.29289 18.2929C3.90237 18.6834 3.90237 19.3166 4.29289 19.7071C4.68342 20.0976 5.31658 20.0976 5.70711 19.7071L12.7071 12.7071C13.0976 12.3166 13.0976 11.6834 12.7071 11.2929L5.70711 4.29289C5.31658 3.90237 4.68342 3.90237 4.29289 4.29289C3.90237 4.68342 3.90237 5.31658 4.29289 5.70711ZM12.7929 7.20711L17.5858 12L12.7929 16.7929C12.4024 17.1834 12.4024 17.8166 12.7929 18.2071C13.1834 18.5976 13.8166 18.5976 14.2071 18.2071L19.7071 12.7071C20.0976 12.3166 20.0976 11.6834 19.7071 11.2929L14.2071 5.79289C13.8166 5.40237 13.1834 5.40237 12.7929 5.79289C12.4024 6.18342 12.4024 6.81658 12.7929 7.20711Z", fill: "" })));
}
export var ArrowDoubleIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: ArrowDoubleIconInner }, props))); };
//# sourceMappingURL=ArrowDoubleIcon.js.map